import HttpService from '../../../common/http/HttpService';
import ReportTemplateEndpoint from '../../../administration/pages/cmms/reportTemplate/const/ReportTemplateEndpoint';
import ReportEndpoint from '../const/ReportEndpoint';
import makeMoment from '../../../common/moment/MomentFactory';
import VcomProvider from '../../../VcomProvider';
import TemplateLightColorDefaultValues
  from '../../../administration/pages/cmms/reportTemplate/const/TemplateLightColorDefaultValues';
import TemplateDarkColorDefaultValues
  from '../../../administration/pages/cmms/reportTemplate/const/TemplateDarkColorDefaultValues';
import TemplateColors from '../../../administration/pages/cmms/reportTemplate/const/TemplateColors';

function updateTemplate(template) {
  const createdDate = makeMoment.utc(template.created).tz(VcomProvider.userTimeZone);
  return {
    ...template,
    created: createdDate,
  };
}

async function getTemplates() {
  const { data } = await HttpService.get(ReportTemplateEndpoint.LIST);
  return data.map((template) => updateTemplate(template));
}

async function saveTemplate(template) {
  return HttpService.post(ReportTemplateEndpoint.SAVE, { config: template });
}

async function removeTemplate(id) {
  await HttpService.post(ReportTemplateEndpoint.REMOVE, { id });
}

async function getTemplateOverview() {
  const response = await HttpService.get(ReportTemplateEndpoint.GET_OVERVIEW);
  return response.data;
}

async function getById(id) {
  const response = await HttpService.post(ReportTemplateEndpoint.GET, { id });
  return response.data;
}

function getFilledFormConfig(formConfig) {
  return Object.keys(formConfig).reduce((accumulator, prop) => {
    const propValue = formConfig[prop];
    const isEmpty = propValue === undefined || propValue === null || propValue === '';
    if (isEmpty === true) {
      return accumulator;
    }
    return { ...accumulator, [prop]: propValue };
  }, {});
}

function getStyleOptions(formConfig) {
  const templateLayout = VcomProvider.Layout.getTheme() === 'mcflat'
    ? TemplateLightColorDefaultValues : TemplateDarkColorDefaultValues;
  const headerBackgroundColor = formConfig.headerBackgroundColor
    ?? templateLayout[TemplateColors.HEADER_BACKGROUND];
  const headerFontColor = formConfig.headerFontColor
    ?? templateLayout[TemplateColors.HEADER_FONT];
  const textFontColor = formConfig.textFontColor
    ?? templateLayout[TemplateColors.TEXT_FONT];
  const fieldBackgroundColor = formConfig.fieldBackgroundColor
    ?? templateLayout[TemplateColors.FIELD_BACKGROUND];

  return {
    ...formConfig,
    headerBackgroundColor,
    headerFontColor,
    textFontColor,
    fieldBackgroundColor,
  };
}

function resetStyleOptions() {
  const templateLayout = VcomProvider.Layout.getTheme() === 'mcflat'
    ? TemplateLightColorDefaultValues : TemplateDarkColorDefaultValues;
  const headerBackgroundColor = templateLayout[TemplateColors.HEADER_BACKGROUND];
  const headerFontColor = templateLayout[TemplateColors.HEADER_FONT];
  const textFontColor = templateLayout[TemplateColors.TEXT_FONT];
  const fieldBackgroundColor = templateLayout[TemplateColors.FIELD_BACKGROUND];

  return {
    headerBackgroundColor,
    headerFontColor,
    textFontColor,
    fieldBackgroundColor,
    fontFamily: undefined,
  };
}

async function prefill(inputs, language, systemId, workOrderId) {
  const response = await HttpService.post(
    ReportEndpoint.PREFILL,
    {
      inputs,
      language,
      systemId,
      workOrderId,
    },
  );
  return response.data;
}

async function getAvailableTokenGroups(groups) {
  const response = await HttpService.post(ReportEndpoint.GET_AVAILABLE_TOKEN_GROUPS, { groups });
  return response.data;
}

const ReportService = {
  getTemplates,
  getById,
  getTemplateOverview,
  getFilledFormConfig,
  getStyleOptions,
  resetStyleOptions,
  saveTemplate,
  removeTemplate,
  prefill,
  getAvailableTokenGroups,
};

export default ReportService;
